import { Bar, ProgressBarRoot } from './ProgressBar.styles'

type ProgressBarProps = {
  step: number
}

export const ProgressBar = ({ step }: ProgressBarProps) => {

  return (
    <ProgressBarRoot>
       <Bar filled={step > 0} />
       <Bar filled={step > 1} />
       <Bar filled={step > 2} />
       <Bar filled={step > 3} />
    </ProgressBarRoot>
  )
}
